import axiosInstance from "./axiosInstance";

export type ApiCategory = "in-house" | "external";

export type UiCategory = ApiCategory;

export interface TourOperatorTypeApi {
  tourOperatorTypeId: number;
  typeName: string;
  code: string;
  category: ApiCategory;
  description: string;
  isActive: boolean;
  releaseDays: number;
}

export interface TourOperatorTypeListQuery {
  searchText?: string | null;
  typeName?: string | null;
  code?: string | null;
  category?: ApiCategory | null;
  isActive?: boolean | null;
  pageNo: number;
  pageSize: number;
}

export interface TourOperatorTypeListResponse {
  items: TourOperatorTypeApi[];
  pageNo: number;
  pageSize: number;
  totalCount: number;
}

/* GET (LIST) */

export const getTourOperatorTypes = async (
  payload: TourOperatorTypeListQuery
): Promise<TourOperatorTypeListResponse> => {
  const res = await axiosInstance.get(
    "/tour-operator-type/list",
    { params: payload }
  );
  return res.data;
};

/* POST (ADD) */

export interface CreateTourOperatorTypePayload {
  typeName: string;
  code: string;
  category: ApiCategory;
  description: string;
  isActive: boolean;
  createdBy: number;
  releaseDays: number;
}

export const createTourOperatorType = async (
  payload: CreateTourOperatorTypePayload
) => {
  const res = await axiosInstance.post(
    "/tour-operator-type",
    payload
  );
  return res.data;
};

/* PUT (UPDATE) */

export const updateTourOperatorType = async (
  id: number,
  payload: {
    tourOperatorTypeId: number;
  typeName: string;
  code: string;
  category: ApiCategory; 
  description: string;
  isActive: boolean;
  updatedBy: number;
  releaseDays: number;
  }
) => {
  const res = await axiosInstance.put(
    `/tour-operator-type/${id}`,
    payload
  );
  return res.data;
};

export interface TourOperatorTypeSummaryResponse {
  totalCount: number;
  activeCount: number;
  inHouseCount: number;
  externalCount: number;
}

export const getTourOperatorTypeSummary = async (): Promise<TourOperatorTypeSummaryResponse> => {
  const res = await axiosInstance.get(
    "/tour-operator-type/summary"
  );
  return res.data;
};
